<div class="fr-view" [innerHTML]="content" data-cy="froala-viewer"></div>
